// This pack will be responsible of holding the initial load of the page
// Will contain Redux store provider, global react router, etc.
require('../src/app/index');
